export const CompaniesBreadcrumb = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Company", path: "/company" },
];
